import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/Login/LoginPage';
import ForgotPasswordPage from './pages/ForgotPassword/ForgotPasswordPage';
import OrderSettingsPage from './pages/OrderSettings/OrderSettingsPage';
import OnboardingPage from './pages/Onboarding/OnboardingPage';
import HomePage from './pages/Home/HomePage'
import NotFound from './pages/404/404';
import RequireAuth from './components/RequireAuth/RequireAuth';
import ProfilePage from './pages/Profile/Profile';
import CheckoutPage from './pages/Checkout/Checkout';
import AllergenPage from './pages/Allergens/Allergens';
import ContactsPage from './pages/Contacts/Contacts';
import TermsPage from './pages/Terms/Terms';
import OrderConfirmationPage from './pages/OrderConfirmation/OrderConfirmation';
import AboutPage from './pages/About/About';
import CreateAccountPage from './pages/CreateAccount/CreateAccount';
import CatalogPage from "./pages/Catalog/Catalog"
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
const AppRoutes = () => {
    // Scroll to top on reroute
    const { pathname } = useLocation();
    useEffect(() => {
        // console.log("URL changed to:", pathname);
        window.scrollTo(0, 0);
    }, [pathname]);

    return(
        <Routes>
            <Route path='login' element={<LoginPage/>}/>
            <Route path='forgot-password' element={<ForgotPasswordPage />} />
            <Route path='forgot-password/:stage' element={<ForgotPasswordPage />} />
            <Route path='create-account' element={<CreateAccountPage />} />
            <Route path='public-catalog' element={<CatalogPage />} />
            <Route path='/' element={
                <RequireAuth>
                    <HomePage />
                </RequireAuth>
                } />
            <Route path='order-settings' element={
                <RequireAuth>
                    <OrderSettingsPage />
                </RequireAuth>
                } />
            <Route path='onboarding' element={
                <RequireAuth>
                    <OnboardingPage />
                </RequireAuth>
                } />

                <Route path="settings/*" >
                 {/* This route has no `element`, so it uses an implicit <Outlet> */}
                    <Route index element={<Navigate to="order" replace />} />
                    <Route path="user" element={<ProfilePage page="user" />} />
                    <Route path="order" element={<ProfilePage page="order" />} />
                    <Route path="address" element={<ProfilePage page="address" />} />
                    <Route path="catalog" element={<ProfilePage page="catalog" />} />
                    <Route path="*" element={<Navigate to="/404" replace />} />
                </Route>
            <Route path='home' element={
                <RequireAuth>
                    <HomePage />
                </RequireAuth>
                } />
            <Route path='checkout' element={
                <RequireAuth>
                    <CheckoutPage />
                </RequireAuth>
                } />
            <Route path='order-confirmation' element={
                <RequireAuth>
                    <OrderConfirmationPage />
                </RequireAuth>
                } />
            <Route path='allergens' element={
                <RequireAuth>
                    <AllergenPage />
                </RequireAuth>
                } />
            <Route path='contacts' element={
                <RequireAuth>
                    <ContactsPage />
                </RequireAuth>
                } />
            <Route path='terms' element={
                <RequireAuth>
                    <TermsPage />
                </RequireAuth>
                } />
            <Route path='about' element={
                <RequireAuth>
                    <AboutPage />
                </RequireAuth>
                } />
            <Route path='*' element={<NotFound />} />
        </Routes>
    )
}
export default AppRoutes